<template>
  <div class="account-list">
    <div class="operation">
      <el-form :inline="true" @submit.native.prevent class="people-form">
        <el-form-item>
          <el-input
            class="search-input"
            placeholder="请输入姓名、工号、账号进行查询"
            prefix-icon="el-icon-search"
            v-model="filter"
            clearable
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="search-btn" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item v-if="addButton && addButton.length" class="add-item">
          <div class="add-buttons" v-if="addButton.length >= 2">
            <el-dropdown split-button @click="event(addButton[0])">
              {{ addButton[0].name }}
              <el-dropdown-menu slot="dropdown" >
                <!-- 只针对于人员管理导入按钮做出修改 -->
                <el-dropdown-item :class="button.name === '导入' && 'account-list-buttons-item'" v-for="(button, index) in addButton" :key="index">
                  <a v-if="index > 0" @click="event(button)">{{ button.name }}</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
           <el-button v-else v-for="(button, index) in addButton" :key="index" type="text" @click="event(button)">+  {{button.name}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
        height="100%"
        highlight-current-row
        @current-change="handleSelectionChange"
        :data="tableData">
        <el-table-column
          v-if="this.selected === true"
          label=""
          width="55">
          <template slot-scope="scope">
            <el-checkbox :value="scope.row===currentRow"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in columnData"
          :prop="column.prop"
          :key="column.prop"
          :label="column.label"
          :resizable="column.resizable"
          :show-overflow-tooltip="true"
          :align="column.align"
          min-width="50"
          :formatter="formatData"
          v-cloak
        ></el-table-column>
        <el-table-column
          v-if="editButotn && editButotn.length > 0"
          label="操作"
          :resizable="false"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button v-for="(button, index) in editButotn" :key="index" type="text" @click="event(button, scope.row)">{{button.name}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="parseInt(paging.totalNum)"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="paging.size"
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page="paging.index"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
const columnData = [
  {
    prop: 'name',
    label: '姓名',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'username',
    label: '账号',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'jobNum',
    label: '工号',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'departmentName',
    label: '部门',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'postName',
    label: '岗位',
    resizable: false,
    align: 'center'
  }
]

export default {
  props: {
    // 是否需要按照部门查询用户, 如果需要, 传入部门相关信息
    deptId: {
      default: '',
      type: String
    },
    // 是否需要选中
    selected: {
      default: false,
      type: Boolean
    },
    // 是否需要无效以及离职的用户, 默认不需要
    useInvalidAccount: {
      default: false,
      type: Boolean
    },
    // todo: 有时间的话, 可以将这两个东西合并
    addButton: {
      // 数组类型的对象, name 放置 按钮的名字, callback 放置回调函数
      type: Array
    },
    editButotn: {
      // 数组类型的对象, name 放置 按钮的名字, callback 放置回调函数
      type: Array
    }
  },
  name: 'accountList',
  data () {
    return {
      filter: '',
      columnData,
      tableData: [],
      currentRow: '',
      paging: {
        totalNum: 0,
        index: 1,
        size: 20
      }
    }
  },
  watch: {
    'deptId' (val) {
      this.paging.index = 1
      this.getAccountList()
    }
  },
  created () {
    if (this.useInvalidAccount && !this.columnData.find(m => m.prop === 'jobStatus')) {
      this.columnData.push({
        prop: 'jobStatus',
        label: '在职状态',
        resizable: false,
        align: 'center'
      },
      {
        prop: 'state',
        label: '用户状态',
        resizable: false,
        align: 'center'
      })
    }
    this.getAccountList()
  },
  methods: {
    search () {
      this.filter = this.filter.trim()
      if (this.filter) {
        this.paging.index = 1
        this.getAccountList()
      }
    },
    // 根据部门 id 查询当前部门人员
    getAccountList () {
      if (this.deptId) {
        let params = {
          index: this.paging.index,
          size: this.paging.size,
          filters: {
            name: this.filter,
            departmentId: this.filter !== '' ? '' : this.deptId,
            useInvalidAccount: this.useInvalidAccount === false ? '0' : '1'
          }
        }
        this.$axios
          .get(`/auth-api/users`, {params})
          .then(res => {
            this.tableData = res.data.items || []
            this.paging.totalNum = res.data.total
          })
      }
    },
    currentChange (val) {
      this.paging.index = val
      this.getAccountList()
    },
    sizeChange (val) {
      this.paging.index = 1
      this.paging.size = val
      this.getAccountList()
    },
    formatData (row, column, cellValue) {
      if (column.property === 'jobStatus') {
        cellValue = cellValue === '1' ? '在职' : '离职'
      } else if (column.property === 'state') {
        cellValue = cellValue === '1' ? '有效' : '无效'
      }
      return cellValue
    },
    event (button, row) {
      if (button && button.callback instanceof Function) {
        row === undefined ? button.callback() : button.callback(row)
      } else {
        console.error('请为按钮配置回调方法')
      }
    },
    handleSelectionChange (row) {
      this.currentRow = row
    }
  }
}
</script>

<style lang="scss">
  .account-list {
    height: 100%;
    .people-form {
      position: relative;
    }
    .search-input  {
      width: 356px;
      height: 26px;
      line-height: 26px;
      input {
       height: 26px;
       line-height: 26px;
      }
    }
    .search-btn.el-button--mini {
      border: 1px solid var(--primary, #62A8F2);
      color: var(--primary, #62A8F2);
      padding: 6px 11px;
    }
    .add-item {
      position: absolute;
      right: 10px;
      .add-buttons {
        .el-dropdown {
          .el-button-group {
            width: 60px;
            .el-button {
              border-color: var(--primary, #62A8F2);
              color: var(--primary, #62A8F2);
              padding: 0;
              height: 26px;
              width: 22px;
              &:first-child {
                width: 38px;
              }
              &:before {
                background-color: var(--primary, #62A8F2);
              }
            }
          }
        }
      }
    }
    .table {
      height: calc(100% - 100px);
      .paging {
        padding-top: 20px;
        height: 40px;
        text-align: right;
      }
    }
  }
  .el-dropdown-menu--mini .account-list-buttons-item {
    padding: 0;
    width: 58px;
    text-align: left;
    & > a {
      margin-left: 8px;
      color: #232323;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/users/account-list.vue